export const PATHS = {
  review: '/reviews',
};
